import { render, staticRenderFns } from "./SStructsList.vue?vue&type=template&id=97c7dd98&scoped=true&"
import script from "./SStructsList.vue?vue&type=script&lang=js&"
export * from "./SStructsList.vue?vue&type=script&lang=js&"
import style0 from "./SStructsList.vue?vue&type=style&index=0&id=97c7dd98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c7dd98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VProgressCircular})
